<template>
  <BaseModalEditCreate
    mode="select"
    :is-modified="false"
    :close-on-outside-click="false"
    max-width="extra"
    :title="title"
    @dismiss-changes="onDismiss"
    @save="onSave">
    <template #form>
      <div class="overflow-hidden h-full grid grid-rows-[auto_1fr]">
        <div class="w-full h-full overflow-x-hidden">
          <BaseTable
            v-if="list"
            table-id="sales-modal-costumers"
            :total-records="totalRecords"
            :headers="treaderSiteHeaders"
            :list="filteredTraderSites"
            only-search
            hide-multiselect-delete
            hide-multiselect-download
            clickable
            disable-multiselect
            :selected-item="selectedTraderSite"
            @table-item-clicked="onSelectRow"
            @refresh-data="onRefreshData" />
        </div>
      </div>
    </template>
  </BaseModalEditCreate>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import BaseModalEditCreate from '@/components/common/BaseModalEditCreate.vue';
import BaseTable from '@/components/common/BaseTable.vue';
import type { TableFilterData } from '@/types/Base';
import type { TraderSite } from '@/types/Traders';

const props = defineProps<{
  list: TraderSite[];
  totalRecords?: number;
  title: string;
}>();

const emit = defineEmits(['refreshData', 'rowSelect', 'dismiss']);

const filteredTraderSites = computed(() => {
  return props.list.filter((x) => !x.deleted);
});

const treaderSiteHeaders = [
  { value: 'name', text: 'Name', type: 'text', active: true },
  { value: 'code', text: 'Code', type: 'text', active: true },
  { value: 'trader.name', text: 'Trader Name', type: 'text', active: true },
  { value: 'address', text: 'Address', type: 'text', active: true },
  { value: 'zipCode', text: 'Zip Code', type: 'text', active: true },
  { value: 'city', text: 'City', type: 'text', active: true },
  { value: 'companySite.name', text: 'Company Site', type: 'text', active: true },
];

const selectedTraderSite = ref<TraderSite>();
function onSelectRow(traderSite: TraderSite) {
  selectedTraderSite.value = traderSite;
}

function onRefreshData(data: TableFilterData) {
  let newPageTotal;
  if (props.totalRecords && data.itemsPerPage) {
    newPageTotal = props.totalRecords / data.itemsPerPage;
  }
  if (newPageTotal && data.page && newPageTotal < data.page) data.page = 1;
  emit('refreshData', data);
}

function onDismiss() {
  emit('dismiss');
}

function onSave() {
  if (selectedTraderSite.value) emit('rowSelect', selectedTraderSite.value);
}
</script>
